import Axios from 'axios';
import Popup, { ToolbarItem } from 'devextreme-react/popup';
import SelectBox from 'devextreme-react/select-box';
import React, { useEffect, useState } from 'react';
import 'react-perfect-scrollbar/dist/css/styles.css';
import 'react-phone-input-2/lib/style.css';
import { toast } from 'react-toastify';
import { Button, Col, FormFeedback, FormGroup, FormText, Input, Row } from 'reactstrap';
import { goRiceUrl } from '../../../../constant/siteConstants';
import PasswordCheck from '../../../../utils/PasswordCheck';
import getConfigToken from '../../../../utils/getConfigToken';

import PhoneInput from 'react-phone-input-2';
import { getAllWarehouses } from '../../../../services/apis';
import useFormatMessage from '../../../../utils/useFormatMessage';
export default function InformationForm({ employeeDetail, toggle, isUpdate, setEmployeeAddModal, trigger, setTrigger }) {

    const notifyError = (message) => toast.error(`${message}`);
    const { t } = useFormatMessage();
    const notifySuccess = (message) => toast.success(`${message}`);
    const [password, setPassword] = useState()
    const [email, setEmail] = useState()
    const [phone, setPhone] = useState()
    // const [cinsiyetValue, setCinsiyetValue] = useState()
    const [warehouse, setWarehouse] = useState([])

    const getAllWarehousesData = async () => {
        try {
            const response = await getAllWarehouses()
            setWarehouse(response)
        } catch (error) {
            console.log(error)
        }
    }
    useEffect(() => {
        getAllWarehousesData()
    }, [])
    useEffect(() => {

        if (employeeDetail) setPhone(employeeDetail.user_phone || "+90")

    }, [employeeDetail])

    const [validationModal, setValidationModal] = useState(false)

    const closeButtonOptions = () => {
        return <Button outline color='danger' onClick={() => { setValidationModal(!validationModal) }} >Vazgeç</Button>
    };

    const setActiveButtonOptions = () => {
        return <Button outline color='success' onClick={() => { setUserActive() }} >Aktif Et</Button>
    };



    const cinsiyet = [{ 'Id': 1, "Name": "Erkek" }, { 'Id': 2, "Name": "Kadın" }];

    async function checkUserEmailIsExist(email) {
        await Axios.post(`${goRiceUrl}/api/employee/checkExists`, { email: email }, getConfigToken)
            .then((resp) => {
                if (resp.data.exists) {
                    notifyError(t("Girmiş olduğunuz Email sistem üzerinde aktif bir kullanıcıya aittir. Lütfen farklı bir Email giriniz."))
                } else {
                    setValidationModal(true)
                }
            }).catch((err) => {
                console.error(err)
            })
    }

    async function setUserActive() {
        // TODO: KALAN MADDE : kullanıcı aktif etme işlemi yapılacak 
        await Axios.post(`${goRiceUrl}/user-management/setActivateEmployee`, { email: email })
            .then((resp) => {
                if (resp.status === 200) {
                    notifySuccess("Kullanıcı aktif edildi.")
                    setEmployeeAddModal(false)
                    setTrigger(!trigger)
                }
            }).catch((err) => {
                console.error(err)
            })
    }

    //eslint-disable-next-line
    let validPassword = false
    const [passwordRulesValidate, setPasswordRulesValidate] = useState(true)
    const passwordCheck = (e) => {
        validPassword = e
        setPasswordRulesValidate(e)
    }


    return (
        <>

            <Row>
                <Col>
                    <Row>
                        {/* <Col md="6">
                            <div className="dx-field">
                                <div className="mb-2" style={{ color: "black", display: 'flex' }}><span>Sicil No</span> &nbsp;
                                    {!isUpdate && <PopoverInfoIcon index="23" text="" textInfo="Sicil Numarası, 'Kullanıcı' tipine sahip kişiler için kullanılabilir. 
                                    Operatörler için sicil numarası otomatik olarak sistem tarafından oluşturulmaktadır. 
                                    Operatörün sisteme sicil numarasıyla giriş yapabilmesi için otomatik olarak oluşturulan sicil numarası, kullanıcının güncelleme sayfasında görüntülenebilir." />}
                                </div>
                                <div className="dx-field" style={{ display: "flex" }}>
                                    <Input
                                        id="sicilNo"
                                        type='text'
                                        placeholder='Lütfen Sicil numarası giriniz...'
                                        defaultValue={employeeDetail.SicilNo}
                                        showClearButton={true}
                                    />
                                </div>
                            </div>
                        </Col> */}
                        <Col md="6">
                            <div className="dx-field">
                                <div className="mb-2" style={{ color: "black" }}>{t("Ad Soyad")} <span style={{ color: "red" }}>*</span></div>
                                <div className="dx-field">
                                    <Input
                                        id="fullName"
                                        type='text'
                                        placeholder={t('Lütfen Ad Soyad giriniz') + "..."}
                                        defaultValue={employeeDetail.full_name}
                                        showClearButton={true}
                                        onChange={(e) => {
                                            let words = e.target.value.split(' ');
                                            let capitalize = words.map(word => word.charAt(0).toUpperCase() + word.slice(1));
                                            document.getElementById("fullName").value = capitalize.join(' ');
                                        }}
                                    />
                                </div>
                            </div>
                        </Col>
                        <Col md="6">
                            <div className="dx-field">
                                <div className="mb-2" style={{ color: "black" }}>{t("Cinsiyet")}  <span style={{ color: "red" }}>*</span></div>
                                <div className="dx-field">
                                    <SelectBox
                                        id='cinsiyet'
                                        // acceptCustomValue={true}
                                        searchEnabled={true}
                                        searchMode="contains"
                                        searchTimeout="200"
                                        dataSource={cinsiyet}
                                        placeholder={t('Cinsiyet Seçiniz') + "..."}
                                        // onValueChanged={(e) => setCinsiyetValue(e.value)}
                                        defaultValue={employeeDetail.cinsiyet}
                                        displayExpr="Name"
                                        valueExpr="Name"
                                    />
                                </div>
                            </div>
                        </Col>

                    </Row>
                    <br />
                    <Row>
                        <Col md="6">
                            <div className="dx-field">
                                <div className="mb-2" style={{ color: "black" }}>{t("Kullanıcı Adı")} <span style={{ color: "red" }}>*</span></div>
                                <div className="dx-field">
                                    <Input
                                        id="userName"
                                        value={email}
                                        type='text'
                                        placeholder={t('Lütfen Kullanıcı Adı giriniz') + "..."}
                                        defaultValue={employeeDetail.user_name}
                                        disabled
                                        autoComplete="new-password"
                                        showClearButton={true}
                                    />
                                </div>
                            </div>
                        </Col>
                        <Col md="6">
                            <div className="dx-field">
                                <div className="mb-2" style={{ color: "black" }}>Email
                                    <span style={{ color: "red" }}>*</span>
                                </div>
                                <div className="dx-field">
                                    <Input className='email'
                                        id="email"
                                        type='text'
                                        value={email}
                                        placeholder={t('Lütfen Email giriniz') + "..."}
                                        defaultValue={employeeDetail.email}
                                        autoComplete="new-password"
                                        showClearButton={true}
                                        onBlur={(e) => checkUserEmailIsExist(email)}
                                        onChange={(e) => { document.getElementById("userName").value = e.target.value; setEmail(e.target.value); }}
                                    />
                                </div>
                            </div>
                        </Col>
                    </Row>

                    <br />
                    <Row>
                        <Col md="6">
                            <div className="dx-field">
                                <div className="mb-2" style={{ color: "black" }}>{t("Şifre")}  <span style={{ color: "red" }}>*</span></div>
                                <div className="dx-field">
                                    <FormGroup className="position-relative">
                                        <Input
                                            autoComplete="new-password"
                                            id="password"
                                            // value={password}
                                            invalid={(password === null || password === "") ? false : passwordRulesValidate === false ? true : false}
                                            onChange={(e) => { setPassword(e.target.value) }}
                                            type='password'
                                            placeholder={t('Lütfen Şifre giriniz') + "..."}
                                            showClearButton={true}
                                            onFocus={(e) => {
                                                if (document.getElementById('password-rule-tooltip')) {
                                                    document.getElementById('password-rule-tooltip').style.visibility = "visible"
                                                }
                                            }}
                                            onBlur={(e) => {
                                                if (document.getElementById('password-rule-tooltip')) {
                                                    document.getElementById('password-rule-tooltip').style.visibility = "hidden"
                                                }
                                            }}
                                        />

                                        <FormFeedback tooltip style={{ background: "#ffd4dc" }} id='password-rule-tooltip'>
                                            <PasswordCheck password={password} passwordCheck={passwordCheck} />
                                        </FormFeedback>
                                        {isUpdate && <FormText>
                                            <span style={{ fontSize: "14px", color: "red" }}>{t("Şifre belirlemeyecekseniz şifre alanlarını boş bırakınız")}. </span>
                                        </FormText>}
                                    </FormGroup>


                                </div>
                            </div>
                        </Col>
                        <Col md="6">
                            <div className="dx-field">
                                <div className="mb-2" style={{ color: "black" }}>{t("Şifre Tekrarı")}  <span style={{ color: "red" }}>*</span></div>
                                <div className="dx-field">
                                    <Input
                                        id="password2"
                                        type='password'
                                        placeholder={t('Lütfen Şifre Tekrarı giriniz') + "..."}
                                        showClearButton={true}
                                    />
                                    {isUpdate && <span style={{ fontSize: "14px", color: "red" }}>{("Şifre belirlemeyecekseniz şifre alanlarını boş bırakınız")}. </span>}
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <br />
                    <Row>
                        <Col md="6">
                            <div className="dx-field">
                                <div className="mb-2" style={{ color: "black" }}>URL</div>
                                <div className="dx-field">

                                    <Input
                                        id="url"
                                        type='text'
                                        placeholder={t('Lütfen URL giriniz') + "..."}
                                        defaultValue={employeeDetail.redirect_path}
                                        showClearButton={true}
                                    />
                                </div>
                            </div>
                        </Col>


                        <Col md="6">
                            <div className="dx-field">
                                <div className="mb-2" style={{ color: "black" }}>{t("Telefon")}</div>
                                <div className="dx-field" id='phone-number'>

                                    <PhoneInput
                                        country={'tr'}
                                        value={phone}
                                        onChange={phone => setPhone(phone)}
                                        isValid={(value, country) => {
                                            if (phone === null) {
                                                return true
                                            }
                                            else if (value === country.dialCode) {
                                                return true
                                            }
                                            else if (country.format?.replaceAll(" ", "").length === value.length + 1) {
                                                return true
                                            }
                                            return false
                                        }}
                                    />
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <br />
                    <Row>
                        <Col md="6">
                            <div className="dx-field">
                                <div className="mb-2" style={{ color: "black" }}>{t("Depo Seçimi")}</div>
                                <div className="dx-field">
                                    <SelectBox
                                        id='depo'
                                        // acceptCustomValue={true}
                                        searchEnabled={true}
                                        searchMode="contains"
                                        searchTimeout="200"
                                        dataSource={warehouse}
                                        placeholder={t('Depo Seçiniz') + "..."}
                                        showClearButton={true}
                                        // onValueChanged={(e) => setCinsiyetValue(e.value)}
                                        defaultValue={employeeDetail.warehouse_id}
                                        displayExpr="warehouse_name"
                                        valueExpr="id"
                                    />
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <br />
                    <Row>
                        <Col md="12">
                            <Button style={{ float: "right" }} onClick={() => { toggle('2'); }} >{t("İleri")}</Button>
                        </Col>
                    </Row>
                    <br />
                </Col >
            </Row >

            <Popup
                visible={validationModal}
                onHiding={() => { setValidationModal(!validationModal) }}
                dragEnabled={true}
                hideOnOutsideClick={true}
                closeOnOutsideClick={true}
                showCloseButton={true}
                showTitle={true}
                title={"Uyarı"}
                container=".dx-viewport"
                width={600}
                shading={false}
                height={"auto"}
            >
                <ToolbarItem
                    widget="dxButton"
                    toolbar="bottom"
                    location="before"
                    render={closeButtonOptions}
                />
                <ToolbarItem
                    widget="dxButton"
                    toolbar="bottom"
                    location="after"
                    render={setActiveButtonOptions}
                />
                <p style={{ fontSize: "15px" }}>
                    {t("inactive_user_message")} <span style={{ color: "red" }}>{t("inactive_user")}</span> {t("continue_message")}.
                    <span style={{ color: "red" }}>{t("activate_user")}</span> {t("or_different_email")}.
                </p>
            </Popup>

        </>
    )
}

